$(document).ready(function(){

    // ajax cart 
    $('.addToCart').on('click', function(e){
        e.preventDefault();     
        
        $.ajax({
            type: 'POST', 
            url: '/cart/add.js',
            data:$(this).parent().serialize(),
            dataType: 'json',            
            success: function(data) {                
              get_cart_details();
              console.log('ok');
            },
            error: function(err){
                console.log('error');
            }
        });
    });

    $('.collection-atc').on('click', function(e){
        e.preventDefault();     
        
        $.ajax({
            type: 'POST', 
            url: '/cart/add.js',
            data:$(this).parent().parent().serialize(),
            dataType: 'json',            
            success: function(data) {                
              get_cart_details();
              console.log('ok');
            },
            error: function(err){
                console.log('error');
            }
        });
    });

    $('.single-product__atc').on('click', function(e){
        e.preventDefault();     
        $(this).addClass('loading');
        $.ajax({
            type: 'POST', 
            url: '/cart/add.js',
            data:$(this).parent().parent().serialize(),
            dataType: 'json',            
            success: function(data) {                
              get_cart_details();
              console.log('ok');
            },
            error: function(err){
                console.log('error');
            }
        });
    });

    function get_cart_details(){
        $.getJSON('/cart.js', function(cart){
            
            var drawer_item_html = '';
            var cart_items = cart.items;        
            var product_total_price = cart.total_price;
            $('body').addClass('cart-shown');
            $('.total-cost').text(my_Shop_Currency +' ' +((product_total_price*0.01).toFixed(0)));            
            $('.cart-count').text('('+cart.item_count+')');            
            var shipping_required = free_shipping_goal - (product_total_price * 0.01).toFixed(0);
            var shipping_progress = ((product_total_price * 0.01) * 100) / free_shipping_goal; 
            $('.cart-progress-bar div').css('width', shipping_progress + '%');
            if(shipping_required >= 1){
                $('.shipping-text').html('Spend another <em class="shipping_purchase-more">'+my_Shop_Currency+shipping_required+'</em> to qualify for free shipping');
            }else {
                $('.shipping-text').html(free_shipping_message);
            }
            for(var i=0; i<=cart_items.length; i++){
                var product_img = cart_items[i].image;
                var product_name = cart_items[i].product_title;
                var product_id = cart_items[i].id;
                var product_name_handlize = product_name.replace(/ /g, "-").toLowerCase();               
                var product_variant_option_name = cart_items[i].options_with_values[0].title;
                var product_variant_option_value = cart_items[i].options_with_values[0].value;
                var product_variant = cart_items[i].variant_title;
                var product_qty = cart_items[i].quantity;
                var product_price = cart_items[i].price;
                var product_variant_id = cart_items[i].variant_id;
                var product_url = cart_items[i].url;
                var product_key = cart_items[i].key;
                var new_product_total_price = cart_items[i].final_line_price;
                var selling_plan = cart_items[i].selling_plan_allocation;               
                // console.log('variation:'+ product_variant);
                drawer_item_html += '<div class="cart-product-item flex">';
                drawer_item_html += '<div class="cart-product-item-thumb">';
                drawer_item_html += '<figure>';
                drawer_item_html += ' <img src="'+ product_img +'" sources="(min-width:1920px)640w, 1025w, 1600w, 100vw" alt="cart-product-item-thumb">';
                drawer_item_html += '</figure>';
                drawer_item_html += '</div>';
                drawer_item_html += '<div class="cart-product-item-content flex">';
                drawer_item_html += '<div class="flex">';
                drawer_item_html += '<div class="flex cart-product-item-content-left">';
                drawer_item_html += '<div class="product-info">';
                drawer_item_html += ' <h6>'+ product_name +'</h6>';
                if(product_variant != null){   
                drawer_item_html += '<em>'+ product_variant +'</em>';   
                }              
                drawer_item_html += '</div>';
                drawer_item_html += '<div class="product-quantity flex">';
                drawer_item_html += '<div class="cart-product-counter flex">';
                drawer_item_html += '<span class="flex button minus-item" onclick="decreaseItem(event,this)" data-id="'+ product_variant_id +'" data-key="'+ product_key +'"><svg width="14" height="2" viewBox="0 0 14 2" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.444 0H0v1.958H13.444V0z" fill="#000"/></svg></span>';
                drawer_item_html += '<input type="number" class="input-num item-count" name="'+ product_variant_id +'" data-id="'+ product_variant_id +'" value="'+ product_qty +'" min="0">';
                drawer_item_html += '<span class="flex button up-btn plus-item" onclick="increaseItem(event, this)" data-id="'+ product_variant_id +'" data-key="'+ product_key +'"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.444 5.844H7.773V0H5.671v5.844H0v1.958h5.671v5.844h2.102V7.802h5.671V5.844z" fill="#000"/></svg></span>';
                drawer_item_html += '</div>';   
                drawer_item_html += '</div>';
                drawer_item_html +=  '</div>';
                drawer_item_html += '<div class="flex cart-product-item-content-right">';
                drawer_item_html += '<div class="cart-product-item-btn">';
                drawer_item_html += '<a href="#" class="cart-item-remove remove-btn" onclick="itemRemove(event, this)" data-id="'+ product_variant_id +'"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.02 13.435 0 1.415 1.414 0l12.021 12.02-1.414 1.415z" fill="#000"/><path fill-rule="evenodd" clip-rule="evenodd" d="M0 12.02 12.02 0l1.415 1.414-12.02 12.021L0 12.021z" fill="#000"/></svg></a>';
                drawer_item_html +=  '</div>';  
                drawer_item_html += '<span class="price  item-price" data-id="'+ product_variant_id +'">'+my_Shop_Currency +' '+(new_product_total_price * 0.01).toFixed(0)+'</span>';
                drawer_item_html += '</div>';
                drawer_item_html += '</div>';

                                 
                
                drawer_item_html +=  '</div>';
                drawer_item_html +=  '</div>';
                $('.cart-wrap').removeClass('cart-empty');
                $('.single-product__atc').removeClass('loading');
                $('.cart-product-item-wrap').html(drawer_item_html);
            }
           
        });
    };
});